import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getTextFromInfo } from '../../../utils'
import DateFormat from '../../helpers/DateFormat'
import ReviewReportModal from './ReviewReportModal'
import ReviewVotes from './ReviewVotes'

const ReviewCard = ({ review, diveSite }) => {
  const [isModalOpen, setModalOpen] = useState(false)

  const handleReport = (e) => {
    setModalOpen(true)
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  const { title } = diveSite
  const certificationLevel = getTextFromInfo(
    review.certificationLevel,
    'account',
    'CERTIFICATION_LEVEL'
  )

  return (
    <article className='review-card'>
      <div className='review-card__header'>
        <div>
          <i
            className={`font-icons ${
              review.isPositive ? 'icon-thumbs-up-new' : 'icon-thumbs-down-new'
            }`}
          />
          <strong className='dark'>
            {review.username} {certificationLevel && `(${certificationLevel})`}
          </strong>
          &nbsp;
          <span>
            {review.isPositive ? (
              <FormattedMessage
                id='review.recomended'
                values={{
                  title,
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
                defaultMessage='Recommends <strong>{title}</strong>'
              />
            ) : (
              <FormattedMessage
                id='review.not_recommended'
                values={{
                  title,
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
                defaultMessage='Does not recommend <strong>{title}</strong>'
              />
            )}
          </span>
        </div>
        <p>
          <DateFormat date={review.created} />
        </p>
      </div>
      <div className='review-card__body'>{review.text}</div>
      <div className='review-card__footer'>
        <ReviewVotes review={review} />
        <a role='button' tabIndex='0' onClick={handleReport}>
          <FormattedMessage id='report' defaultMessage='Report' />
        </a>
        <ReviewReportModal
          isOpen={isModalOpen}
          closeModal={handleModalClose}
          reviewId={review.objectId}
        />
      </div>
    </article>
  )
}

export default ReviewCard
